import { render, staticRenderFns } from "./ErrorStep.vue?vue&type=template&id=b6faeb02&scoped=true"
import script from "./ErrorStep.vue?vue&type=script&lang=js"
export * from "./ErrorStep.vue?vue&type=script&lang=js"
import style0 from "./ErrorStep.vue?vue&type=style&index=0&id=b6faeb02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6faeb02",
  null
  
)

export default component.exports